import './DocumentTemplates.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../../store/selectors';
import Helpers from '../../../../utils/helper';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import paginationFactory from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-paginator';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import filterFactory from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan, faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import { TemplateTypes } from '../../../../models/SignDocumentModule/TemplateTypes';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import { AddDocumentTemplateModal } from './AddDocumentTemplateModal/AddDocumentTemplateModal';
import { DocumentTemplate } from '../../../../slices/marketplace/timeline/models/document-template.model';
import { SampleTemplate } from '../../../../slices/marketplace/timeline/models/sample-template.model';
import { GetDocumentTemplates } from '../../../../slices/marketplace/timeline/thunks/get-document-templates.thunk';
import { GetSampleTemplates } from '../../../../slices/marketplace/timeline/thunks/get-sample-templates.thunk';
import createNotification from '../../../../utils/createNotification';
import { DocumentDetails } from '../../../../slices/marketplace/timeline/models/document-details.model';
import DocumentTemplateRenameModal from '../../Modals/TimelineCopyModal copy/DocumentTemplateRenameModal';
import { AddSampleTemplateModal } from './AddSampleTemplateModal/AddSampleTemplateModal';

const DocumentTemplates = () => {
    const dispatch = useDispatch() as any;
    const documentTemplatesTable = useStateSelector(
        (state) => state.timelines.documentTemplatesTable
    );
    const sampleTemplatesTable = useStateSelector(
        (state) => state.timelines.sampleTemplatesTable
    );
    const axios = useStateSelector((state) => state.core.axios);
    const [page, setPage] = useState(1);
    const [totalSize, setTotalSize] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(5);
    const [documentTemplates, setDocumentTemplates] = useState<
        DocumentTemplate[]
    >([]);

    const [selectedTemplate, setSelectedTemplate] =
        useState<DocumentTemplate>();

    const [
        activeEngagementDocumentTemplates,
        setActiveEngagementDocumentTemplates,
    ] = useState<DocumentDetails[]>();

    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
    const [
        isRemoveConfirmationPopupVisible,
        setIsRemoveConfirmationPopupVisible,
    ] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const [sampleTemplates, setSampleTemplates] = useState<SampleTemplate[]>([]);
    const [samplePage, setSamplePage] = useState(1);
    const [sampleTotalSize, setSampleTotalSize] = useState(0);
    const [sampleSizePerPage, setSampleSizePerPage] = useState(5);
    const [isSampleLoading, setIsSampleLoading] = useState(true);
    const [isAddSampleModalVisible, setIsAddSampleModalVisible] = useState(false);
    const [isRenameSampleModalVisible, setIsRenameSampleModalVisible] = useState(false);
    const [selectedSampleTemplate, setSelectedSampleTemplate] = useState<SampleTemplate>();
    const [isRemoveSampleConfirmationPopupVisible, setIsRemoveSampleConfirmationPopupVisible] = useState(false);

    const defaultSorted: [{ dataField: any; order: any }] = [
        {
            dataField: 'id',
            order: 'asc',
        },
    ];
    const [currentSort, setCurrentSort] = useState<TableFilter>(
        new TableFilter({ filters: [], logic: '' }, page, sizePerPage, {
            dir: 'asc',
            field: 'Id',
        })
    );

    const templatesColumns = [
        {
            dataField: 'id',
            text: 'Id',
            hidden: true,
        },
        {
            dataField: 'name',
            text: 'Template Name',
            headerClasses: 'name-column-header',
            sort: true,
            formatter: (cellContent: string) =>
                !cellContent ? 'NA' : cellContent,
        },
        {
            dataField: '',
            text: 'Actions',
            headerClasses: 'actions-column-header',
            headerFormatter: () => (
                <div className="d-flex justify-content-between w-100">
                    <div className="w-100">Actions</div>
                </div>
            ),
            style: {
                minWidth: 350,
            },
            formatter: (_cellContent: number, row: DocumentTemplate) => {
                const isTemplateActive =
                    activeEngagementDocumentTemplates?.some(
                        (template) => template.templateId === row.id
                    );

                const isSignRequest = row.type === TemplateTypes.SignRequest;

                return (
                    <>
                        <div className="action-icons">
                            <FontAwesomeIcon
                                icon={faEdit}
                                className="cursor-pointer"
                                onClick={() => {
                                    setSelectedTemplate(row);
                                    setIsRenameModalVisible(true);
                                }}
                            />
                            <FontAwesomeIcon
                                className={`${
                                    !isTemplateActive
                                        ? 'delete-button cursor-pointer'
                                        : 'text-muted'
                                }`}
                                icon={faTrashCan}
                                onClick={() => {
                                    if (!isTemplateActive) {
                                        setSelectedTemplate(row);
                                        setIsRemoveConfirmationPopupVisible(
                                            true
                                        );
                                    }
                                }}
                                title={
                                    isTemplateActive
                                        ? 'This template is in use'
                                        : ''
                                }
                            />
                            <FontAwesomeIcon
                                icon={isSignRequest ? faEye : faDownload}
                                className="cursor-pointer"
                                title={isSignRequest ? 'View template' : 'Download template'}
                                onClick={async () => {
                                    const response = await axios.get(
                                        `/api/SignTemplates/${row.id}/fileUrl`
                                    );
                                    window.open(response.data, '_blank');
                                }}
                            />
                        </div>
                    </>
                );
            },
        },
    ];

    const sampleTemplatesColumns = [
        {
            dataField: 'id',
            text: 'Id',
            hidden: true,
        },
        {
            dataField: 'name',
            text: 'File Name',
            headerClasses: 'name-column-header',
            sort: true,
            formatter: (cellContent: string) =>
                !cellContent ? 'NA' : cellContent,
        },
        {
            dataField: '',
            text: 'Actions',
            headerClasses: 'actions-column-header',
            headerFormatter: () => (
                <div className="d-flex justify-content-between w-100">
                    <div className="w-100">Actions</div>
                </div>
            ),
            style: {
                minWidth: 150,
            },
            formatter: (_cellContent: number, row: SampleTemplate) => {
                return (
                    <div className="action-icons">
                        <FontAwesomeIcon
                            icon={faEdit}
                            className="cursor-pointer"
                            onClick={() => {
                                setSelectedSampleTemplate(row);
                                setIsRenameSampleModalVisible(true);
                            }}
                        />
                        <FontAwesomeIcon
                            className="delete-button cursor-pointer"
                            icon={faTrashCan}
                            onClick={() => {
                                setSelectedSampleTemplate(row);
                                setIsRemoveSampleConfirmationPopupVisible(true);
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const handleTableChange = (
        _type: any,
        newState: {
            page: number;
            sizePerPage: number;
            sortField: string;
            sortOrder: 'asc' | 'desc';
            filters: {
                [key: string]: {
                    filterVal: any;
                    filterType: string;
                    comparator: any;
                };
            };
        }
    ) => {
        const updatedPostObj = new TableFilter(
            { filters: [], logic: '' },
            newState.page,
            newState.sizePerPage,
            { dir: newState.sortOrder, field: newState.sortField }
        );

        setCurrentSort(updatedPostObj);
        setPage(newState.page);
        setSizePerPage(newState.sizePerPage);

        fetchDocumentTemplates(updatedPostObj);
    };

    const fetchDocumentTemplates = async (newSort?: TableFilter) => {
        await dispatch(GetDocumentTemplates(newSort || currentSort));
    };

    const fetchSampleTemplates = async (newSort?: TableFilter) => {
        const sortParams = newSort || new TableFilter(
            { filters: [], logic: '' },
            samplePage,
            sampleSizePerPage,
            { dir: 'asc', field: 'Id' }
        );
        await dispatch(GetSampleTemplates(sortParams));
    };

    const handleSampleTableChange = (
        _type: any,
        newState: {
            page: number;
            sizePerPage: number;
            sortField: string;
            sortOrder: 'asc' | 'desc';
            filters: {
                [key: string]: {
                    filterVal: any;
                    filterType: string;
                    comparator: any;
                };
            };
        }
    ) => {
        const updatedPostObj = new TableFilter(
            { filters: [], logic: '' },
            newState.page,
            newState.sizePerPage,
            { dir: newState.sortOrder, field: newState.sortField }
        );

        fetchSampleTemplates(updatedPostObj);
    };

    const handleRemoveSampleTemplate = async (id: number) => {
        setIsSampleLoading(true);
        const response = await axios.delete(`/api/Marketplace/MarketplaceSampleTemplates/${id}`);
        if (response.status !== 200) {
            createNotification(
                'An unexpected error occurred during Sample Template removal.',
                'error'
            );
            setIsSampleLoading(false);
            return;
        } else {
            await fetchSampleTemplates();
            setIsRemoveSampleConfirmationPopupVisible(false);
            setIsSampleLoading(false);
        }
    };

    const fetchActiveEngagementDocumentTemplates = async () => {
        try {
            const response = await axios.get(
                `api/Marketplace/Engagements/unsignedEngagementDocuments`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Engagements Document Templates at the moment.',
                    'error'
                );
                throw new Error(
                    'Failed to fetch Engagements Document Templates'
                );
            }

            const engagementDocumentTemplates: DocumentDetails[] =
                response.data;

            setActiveEngagementDocumentTemplates(engagementDocumentTemplates);
        } catch (error) {
            createNotification(
                'An error occurred while fetching Timeline Templates.',
                'error'
            );
            throw error;
        }
    };

    useEffect(() => {
        setIsLoading(true);
        setIsSampleLoading(true);

        Promise.all([
            fetchDocumentTemplates(),
            fetchActiveEngagementDocumentTemplates(),
            fetchSampleTemplates(),
        ]).finally(() => {
            setIsLoading(false);
            setIsSampleLoading(false);
        });
    }, []);

    useEffect(() => {
        setDocumentTemplates(documentTemplatesTable.templates);
        setPage(documentTemplatesTable.pageNumber);
        setTotalSize(documentTemplatesTable.totalItems);
        setSizePerPage(documentTemplatesTable.pageSize);
    }, [documentTemplatesTable]);

    useEffect(() => {
        setSampleTemplates(sampleTemplatesTable.templates);
        setSamplePage(sampleTemplatesTable.pageNumber);
        setSampleTotalSize(sampleTemplatesTable.totalItems);
        setSampleSizePerPage(sampleTemplatesTable.pageSize);
    }, [sampleTemplatesTable]);

    const handleRemoveTemplate = async (id: number) => {
        setIsLoading(true);
        const response = await axios.delete(`/api/SignTemplates/${id}`);
        if (response.status !== 200) {
            createNotification(
                'An unexpected error occurred during Document Template removal.',
                'error'
            );
            setIsLoading(false);
            return;
        } else {
            await fetchDocumentTemplates();
            setIsRemoveConfirmationPopupVisible(false);
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="document-templates">
                <div>
                    <div className="mb-3">
                        <strong>Document Templates</strong>
                        <Button
                            type="button"
                            className="btn btn-primary ml-3"
                            onClick={() => {
                                setIsAddModalVisible(true);
                            }}>
                            Add New
                        </Button>
                    </div>
                    <div
                        role="tabpanel"
                        id="panel-0"
                        aria-labelledby="tab-0"
                        aria-hidden="false">
                        <div className="card-body">
                            {isLoading ? (
                                Helpers.renderTableLoader()
                            ) : (
                                <BootstrapTable
                                    striped
                                    bordered
                                    bootstrap4
                                    remote
                                    keyField="id"
                                    data={documentTemplates}
                                    columns={templatesColumns}
                                    defaultSorted={defaultSorted}
                                    filter={filterFactory()}
                                    pagination={paginationFactory({
                                        page,
                                        sizePerPage,
                                        totalSize,
                                        tooltipTargetId:
                                            'timeline-templates-tooltip',
                                    })}
                                    onTableChange={handleTableChange}
                                    noDataIndication="No Templates to display"
                                    rowStyle={{ height: '44px' }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="document-templates sample-templates-section">
                <div>
                    <div className="mb-3">
                        <strong>Connect Marketplace Templates</strong>
                        <Button
                            type="button"
                            className="btn btn-primary ml-3"
                            onClick={() => {
                                setIsAddSampleModalVisible(true);
                            }}>
                            Add New
                        </Button>
                    </div>
                    <div
                        role="tabpanel"
                        id="panel-1"
                        aria-labelledby="tab-1"
                        aria-hidden="false">
                        <div className="card-body">
                            {isSampleLoading ? (
                                Helpers.renderTableLoader()
                            ) : (
                                <BootstrapTable
                                    striped
                                    bordered
                                    bootstrap4
                                    remote
                                    keyField="id"
                                    data={sampleTemplates}
                                    columns={sampleTemplatesColumns}
                                    defaultSorted={defaultSorted}
                                    filter={filterFactory()}
                                    pagination={paginationFactory({
                                        page: samplePage,
                                        sizePerPage: sampleSizePerPage,
                                        totalSize: sampleTotalSize,
                                        tooltipTargetId:
                                            'sample-templates-tooltip',
                                    })}
                                    onTableChange={handleSampleTableChange}
                                    noDataIndication="No Templates to display"
                                    rowStyle={{ height: '44px' }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isAddModalVisible ? (
                <AddDocumentTemplateModal
                    onClose={() => setIsAddModalVisible(false)}
                    isOpened={isAddModalVisible}
                    afterSuccessfulAdd={() => {
                        fetchDocumentTemplates();
                        setIsAddModalVisible(false);
                    }}
                />
            ) : (
                []
            )}
            {isRemoveConfirmationPopupVisible ? (
                <ConfirmationModal
                    isVisible={isRemoveConfirmationPopupVisible}
                    setIsVisible={() => {
                        setSelectedTemplate(undefined);
                        setIsRemoveConfirmationPopupVisible(false);
                    }}
                    header={'Are you sure?'}
                    confirmationText={
                        'Are you sure you want to delete this template?'
                    }
                    onConfirm={() => handleRemoveTemplate(selectedTemplate.id)}
                    params={undefined}
                    cancelButtonText={'No, take me back'}
                    nextButtonText={`Yes, I'm sure`}
                />
            ) : (
                []
            )}
            {isRenameModalVisible ? (
                <DocumentTemplateRenameModal
                    templateId={selectedTemplate.id}
                    currentName={selectedTemplate.name}
                    isVisible={isRenameModalVisible}
                    onClose={() => setIsRenameModalVisible(false)}
                    fetchData={() => fetchDocumentTemplates()}
                />
            ) : (
                []
            )}
            {isAddSampleModalVisible ? (
                <AddSampleTemplateModal
                    onClose={() => setIsAddSampleModalVisible(false)}
                    isOpened={isAddSampleModalVisible}
                    afterSuccessfulAdd={() => {
                        fetchSampleTemplates();
                        setIsAddSampleModalVisible(false);
                    }}
                />
            ) : (
                []
            )}
            {isRemoveSampleConfirmationPopupVisible ? (
                <ConfirmationModal
                    isVisible={isRemoveSampleConfirmationPopupVisible}
                    setIsVisible={() => {
                        setSelectedSampleTemplate(undefined);
                        setIsRemoveSampleConfirmationPopupVisible(false);
                    }}
                    header={'Are you sure?'}
                    confirmationText={
                        'Are you sure you want to delete this template?'
                    }
                    onConfirm={() => handleRemoveSampleTemplate(selectedSampleTemplate.id)}
                    params={undefined}
                    cancelButtonText={'No, take me back'}
                    nextButtonText={`Yes, I'm sure`}
                />
            ) : (
                []
            )}
            {isRenameSampleModalVisible ? (
                <DocumentTemplateRenameModal
                    templateId={selectedSampleTemplate.id}
                    currentName={selectedSampleTemplate.name}
                    isVisible={isRenameSampleModalVisible}
                    onClose={() => setIsRenameSampleModalVisible(false)}
                    fetchData={() => fetchSampleTemplates()}
                />
            ) : (
                []
            )}
        </>
    );
};

export default DocumentTemplates;
